import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { FaImage } from "react-icons/fa";

const AddAgentModal = ({ show, handleClose, addAgent }) => {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    department: "",
    designation: "",
    about: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newId = `Agt-${String(Math.floor(Math.random() * 1000)).padStart(3, "0")}`;

    addAgent({
      id: newId,
      name: `${form.firstName} ${form.lastName}`,
      email: form.email,
      role: form.designation,
      assigned: 0,
      resolved: 0,
      status: "Available",
      img: "/assets/img/agents/agent-01.jpg",
    });

    handleClose();

    setForm({
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      department: "",
      designation: "",
      about: "",
    });
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Add New Agent</Modal.Title>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {/* IMAGE UPLOAD */}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
              border: "1px dashed #ddd",
              padding: "15px",
              borderRadius: "8px",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                width: "90px",
                height: "90px",
                borderRadius: "50%",
                border: "1px dashed #bbb",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FaImage size={26} />
            </div>

            <div>
              <h6 className="mb-1">Upload Profile Image</h6>

              <p style={{ fontSize: "12px" }}>Image should be below 4 mb</p>

              <div className="d-flex gap-2">
                <label
                  style={{
                    background: "#f26522",
                    color: "#fff",
                    padding: "6px 15px",
                    borderRadius: "6px",
                    cursor: "pointer",
                  }}
                >
                  Upload
                  <input type="file" style={{ display: "none" }} />
                </label>

                <Button variant="light" size="sm">
                  Cancel
                </Button>
              </div>
            </div>
          </div>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  First Name <span className="text-danger">*</span>
                </Form.Label>

                <Form.Control
                  name="firstName"
                  value={form.firstName}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Last Name</Form.Label>

                <Form.Control
                  name="lastName"
                  value={form.lastName}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Phone Number <span className="text-danger">*</span>
                </Form.Label>

                <Form.Control
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Email <span className="text-danger">*</span>
                </Form.Label>

                <Form.Control
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Department <span className="text-danger">*</span>
                </Form.Label>

                <Form.Select
                  name="department"
                  value={form.department}
                  onChange={handleChange}
                  required
                >
                  <option>Select</option>
                  <option>Finance</option>
                  <option>UI/UX</option>
                  <option>Marketing</option>
                  <option>Administration</option>
                  <option>Web Development</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Designation <span className="text-danger">*</span>
                </Form.Label>

                <Form.Select
                  name="designation"
                  value={form.designation}
                  onChange={handleChange}
                  required
                >
                  <option>Select</option>
                  <option>Senior Support Agent</option>
                  <option>Junior Support Agent</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group>
                <Form.Label>About</Form.Label>

                <Form.Control
                  as="textarea"
                  rows={3}
                  name="about"
                  value={form.about}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="light" onClick={handleClose}>
            Cancel
          </Button>

          <Button
            type="submit"
            style={{
              background: "#f26522",
              border: "none",
            }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddAgentModal;
